import React from 'react';

import type { RouteObject } from 'react-router-dom';

import { ViolationActFormStep } from './';

const ViolationActFormDevices = React.lazy(
  () => import('@/pages/ViolationActForm/views/Devices'),
);

const ViolationActFormInformation = React.lazy(
  () => import('@/pages/ViolationActForm/views/Information'),
);

export const ActFormView: Record<keyof typeof ViolationActFormStep, string> = {
  Information: '',
  Devices: 'devices',
};

export const violationActFormRoutes: RouteObject[] = [
  {
    path: ActFormView.Information,
    element: <ViolationActFormInformation />,
    index: true,
  },
  {
    path: ActFormView.Devices,
    element: <ViolationActFormDevices />,
  },
];
